import * as tracking from 'dibs-tracking';

export type PromoTrackingObject = {
    id: string;
    name: string;
    creative: string;
    position: number;
};

export type PromoTrackingItem = {
    linkData?: {
        path?: string | null;
    } | null;
    imageUrl?: string | null;
};

export function buildPromoTrackingObject({
    id,
    name,
    item,
    index = 0,
}: {
    id: string;
    name: string;
    item: PromoTrackingItem | null;
    index?: number;
}): PromoTrackingObject {
    const url = item?.linkData?.path || item?.imageUrl || '';
    const position = index + 1;
    return {
        id,
        name,
        creative: url,
        position: position,
    };
}

export function trackPromoImpressions(promoTrackingObjects: PromoTrackingObject[]): void {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: promoTrackingObjects,
    });
}

export function trackPromoClick(promoTrackingObject: PromoTrackingObject): void {
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [promoTrackingObject],
    });
}
